import type { TranslationKey } from '@/shared/i18n'

export const DOCUMENT_TYPES = [
  'residence_permit',
  'passport',
  'insurance',
  'driving_licence',
  'tax_document',
  'employment_contract',
  'rental_contract',
  'bank_document',
  'utility_bill',
  'marriage_certificate',
  'birth_certificate',
  'other',
] as const

export type DocumentType = (typeof DOCUMENT_TYPES)[number]

const icons: Record<DocumentType, string> = {
  residence_permit: '🏠',
  passport: '🛂',
  insurance: '🛡',
  driving_licence: '🚗',
  tax_document: '💰',
  employment_contract: '💼',
  rental_contract: '🔑',
  bank_document: '🏦',
  utility_bill: '💡',
  marriage_certificate: '💍',
  birth_certificate: '👶',
  other: '📄',
}

const surveys: Partial<Record<DocumentType, string>> = {
  residence_permit: 'residence-permit',
}

export function documentSurvey(type: string): string | undefined {
  return isDocumentType(type) ? surveys[type] : undefined
}

export function isDocumentType(candidate: string): candidate is DocumentType {
  return (DOCUMENT_TYPES as readonly string[]).includes(candidate)
}

export function documentIcon(type: string): string {
  return isDocumentType(type) ? icons[type] : icons.other
}

export function documentTypeLabel(type: string): TranslationKey {
  return `documents.type.${isDocumentType(type) ? type : 'other'}` as TranslationKey
}

const arcShape = /^05\d{8}$/

export function carriesArc(document: { type: string; issuing_country?: string }): boolean {
  return document.type === 'residence_permit' && document.issuing_country === 'CY'
}

export function isArc(value: string): boolean {
  return arcShape.test(value)
}

export function numberLabel(document: { type: string; issuing_country?: string }): TranslationKey {
  return carriesArc(document) ? 'documents.number.arc' : 'documents.number'
}

export function numberHint(document: { type: string; issuing_country?: string }): TranslationKey {
  return carriesArc(document) ? 'documents.number.hint.arc' : 'documents.number.hint'
}
